import React from 'react';
import {
  FaXTwitter,
  FaYoutube,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaBluesky,
  FaDiscord,
  FaTumblr,
  FaTelegram,
  FaThreads,
} from 'react-icons/fa6';
import { Share2 } from 'lucide-react';

// Workaround for react-icons v5 type incompatibility with @types/react@18.2
const Icon = (Component: any, className: string) => React.createElement(Component, { className });

export function getPlatformIcon(platform: string, sizeClassName: string = 'h-3 w-3'): JSX.Element {
  const p = platform.toLowerCase();
  if (p.includes('twitter') || p === 'x' || p === 'x-es') return Icon(FaXTwitter, sizeClassName);
  if (p.includes('youtube')) return Icon(FaYoutube, sizeClassName);
  if (p.includes('instagram')) return Icon(FaInstagram, sizeClassName);
  if (p.includes('facebook')) return Icon(FaFacebook, sizeClassName);
  if (p.includes('tiktok')) return Icon(FaTiktok, sizeClassName);
  if (p.includes('bluesky')) return Icon(FaBluesky, sizeClassName);
  if (p.includes('discord')) return Icon(FaDiscord, sizeClassName);
  if (p === 'tumblr') return Icon(FaTumblr, sizeClassName);
  if (p === 'telegram') return Icon(FaTelegram, sizeClassName);
  if (p.includes('threads')) return Icon(FaThreads, sizeClassName);
  return <Share2 className={sizeClassName} />;
}

export function getPlatformColor(platform: string): string {
  const p = platform.toLowerCase();
  if (p.includes('twitter') || p === 'x' || p === 'x-es') return '#000000';
  if (p.includes('youtube')) return '#FF0000';
  if (p.includes('instagram')) return '#E1306C';
  if (p.includes('facebook')) return '#1877F2';
  if (p.includes('tiktok')) return '#ff0050';
  if (p.includes('bluesky')) return '#0085FF';
  if (p.includes('threads')) return '#000000';
  if (p === 'tumblr') return '#35465c';
  if (p.includes('discord')) return '#5865F2';
  if (p === 'telegram') return '#0088cc';
  return 'hsl(var(--primary))';
}

export function getPlatformName(platform: string): string {
  const p = platform.toLowerCase();
  if (p.includes('twitter') || p === 'x') return 'X / Twitter';
  if (p === 'x-es') return 'X / Twitter (ES)';
  if (p.includes('youtube')) return 'YouTube';
  if (p.includes('instagram')) return 'Instagram';
  if (p.includes('facebook')) return 'Facebook';
  if (p.includes('tiktok')) return 'TikTok';
  if (p.includes('bluesky')) return 'Bluesky';
  if (p.includes('discord')) return 'Discord';
  if (p === 'tumblr') return 'Tumblr';
  if (p === 'telegram') return 'Telegram';
  if (p.includes('threads')) return 'Threads';
  return platform;
}

export function buildPlatformUrl(platform: string, externalPostId?: string, handle?: string): string {
  if (!externalPostId) return '';
  const p = platform.toLowerCase();
  if (p.includes('twitter') || p === 'x' || p === 'x-es') {
    return `https://x.com/i/web/status/${externalPostId}`;
  }
  if (p.includes('tiktok')) {
    return `https://www.tiktok.com/@${handle || ''}/video/${externalPostId}`;
  }
  if (p.includes('bluesky')) {
    const postPart = externalPostId.split('/').pop();
    return `https://bsky.app/profile/${handle || ''}/post/${postPart}`;
  }
  if (p === 'telegram') {
    if (handle && handle.startsWith('@')) {
      return `https://t.me/${handle.substring(1)}/${externalPostId}`;
    } else if (handle && !handle.includes(' ')) {
      return `https://t.me/${handle}/${externalPostId}`;
    }
  }
  return '';
}
